<template>
    <div class="payment-term-list clearfix">
        <TableList
            v-bind="tableListData"
            @on-radio-change="checkChange"
        ></TableList>
        <compModal v-model="operate.show" v-bind="operate">
            <component :is="operate.component" v-bind="operate" v-on="operate.on"></component>
        </compModal>
        <div class="pull-right" style="margin: 15px 0;">
            <Button type="primary" class="margin-right-15" @click="handleConfirm">确定</Button>
            <Button type="default" @click="$emit('on-close')">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpPaymentTermList } from "@/service/purchase/purchase";
import TableList from "@components/templates/tablelist";
import compPaymentDetail from "./paymenttermdetail.vue";
export default {
    components: {
        TableList,
        compPaymentDetail,
    },
    data() {
        return {
            checkItemData: {},
            operate: {
                show: false
            },
        };
    },
    computed: {
        tableListData() {
            let widthStyle = "width: 150px;";
            return {
                Searchs: {
                    show: true,
                    style: "border:none;",
                    align: "left",
                },
                ajaxRequest: HttpPaymentTermList,
                SearchsData: [
                    {
                        label: "Payment Term Name",
                        tag: "vInput",
                        key: "CN_paymentName",
                        show: true,
                        style: widthStyle,
                    },
                    {
                        label: "Payment Term Desciption",
                        tag: "vInput",
                        key: "CN_paymentDescription",
                        show: true,
                        style: widthStyle,
                    },
                ],
                columns: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center",
                        formName: "id",
                        isRadio: true,
                    },
                    {
                        title: "Payment Term Name",
                        key: "paymentName",
                        render: (h, { row }) => {
                            return <a onClick={this.queryDetail.bind(this, row.id)}>{row.paymentName}</a>
                        }
                    },
                    {
                        title: "Payment Term Description",
                        key: "paymentDescription",
                    },
                ],
            };
        },
    },
    methods: {
        checkChange(data) {
            console.log(data);
            this.checkItemData = data;
        },
        queryDetail (id) {
            this.operate = {
                show: true,
                title: "详情",
                width: 1200,
                component: "compPaymentDetail",
                querytype: 'query',
                params: id,
                showFooter: false
            }
        },
        handleConfirm () {
            this.$emit('on-confirm', this.checkItemData);
        },
    },
};
</script>

<style>
</style>